import { AdjustmentType } from 'enums';

const AdjustmentTypeLabels = {
    [AdjustmentType.CustomerDeduction]: 'Customer Deduction',
    [AdjustmentType.CustomerDedRepay]: 'Customer Ded. Repay',
    [AdjustmentType.DotBillback]: 'Dot Billback',
    [AdjustmentType.DotCreditToSupplier]: 'Dot Credit to Supplier',
    [AdjustmentType.Discount]: 'Discount',
    [AdjustmentType.Pricing]: 'Pricing Adjustment',
    [AdjustmentType.Quantity]: 'Quantity Adjustment',
    [AdjustmentType.SpecialPricing]: 'Pricing Adjustment'
};

export default function getAdjustmentTypeLabel(type: AdjustmentType) {
    return AdjustmentTypeLabels[type as keyof typeof AdjustmentTypeLabels];
}  
